"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_hooks_1 = require("@onemedical/react-hooks");
var is_url_1 = tslib_1.__importDefault(require("is-url"));
var object_hash_1 = tslib_1.__importDefault(require("object-hash"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
function MicroFrontend(_a) {
    var id = _a.id, host = _a.host, history = _a.history, containedAppProps = _a.containedAppProps, onError = _a.onError, children = _a.children;
    var onErrorCallback = react_hooks_1.useEventCallback(onError);
    react_1.useEffect(function () {
        function unlink() {
            document
                .querySelectorAll("script[data-id='" + id + "'], link[data-id='" + id + "'], meta[data-id='" + id + "']")
                .forEach(function (e) { return e.parentNode.removeChild(e); });
        }
        function render() {
            if (window[id + "Render"]) {
                window[id + "Render"](history, containedAppProps);
            }
        }
        function loadAssets() {
            var _a;
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var response, manifest, currentVersion, newVersion, meta, error_1;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 3, , 4]);
                            return [4 /*yield*/, fetch(new URL('asset-manifest.json', host + "/").href)];
                        case 1:
                            response = _b.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            manifest = _b.sent();
                            currentVersion = (_a = document.querySelector("meta[name='asset-version'][data-id='" + id + "']")) === null || _a === void 0 ? void 0 : _a.content;
                            newVersion = object_hash_1["default"](manifest.entrypoints);
                            if (!currentVersion || newVersion !== currentVersion) {
                                unlink();
                                manifest.entrypoints.forEach(function (path) {
                                    var assetUrl = new URL(path, host + "/").href;
                                    if (path.endsWith('.js')) {
                                        var script = document.createElement('script');
                                        script.src = assetUrl;
                                        script.setAttribute('data-id', id);
                                        script.onload = render;
                                        document.head.appendChild(script);
                                    }
                                    if (path.endsWith('.css')) {
                                        var link = document.createElement('link');
                                        link.href = assetUrl;
                                        link.setAttribute('rel', 'stylesheet');
                                        link.setAttribute('data-id', id);
                                        document.head.appendChild(link);
                                    }
                                });
                                meta = document.createElement('meta');
                                meta.name = 'asset-version';
                                meta.setAttribute('data-id', id);
                                meta.content = newVersion;
                                document.head.appendChild(meta);
                            }
                            else {
                                render();
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _b.sent();
                            onErrorCallback(error_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        loadAssets();
        return function () {
            if (window[id + "Unmount"]) {
                window[id + "Unmount"]();
            }
        };
    }, [id, host, history, containedAppProps, onErrorCallback]);
    return react_1["default"].createElement("div", { id: id + "-container" }, children);
}
function createUrlPropType() {
    return function (props, propName, componentName) {
        var value = props[propName]; // eslint-disable-line react/destructuring-assignment
        if (!value)
            return new TypeError("Missing '" + propName + "' on '" + componentName + "'");
        if (!is_url_1["default"](value)) {
            return new TypeError("Invalid prop '" + propName + "' passed to '" + componentName + "'. Expected a valid URL.");
        }
        return null;
    };
}
var urlPropType = createUrlPropType();
urlPropType.isRequired = createUrlPropType();
MicroFrontend.propTypes = {
    /** A unique identifier for this micro-frontend */
    id: prop_types_1["default"].string.isRequired,
    /** The URL where the micro-frontend app is hosted */
    host: urlPropType.isRequired,
    /** The history object to be shared with the micro-frontends app */
    history: prop_types_1["default"].object.isRequired,
    /** Optional props to be passed to the micro-frontend */
    containedAppProps: prop_types_1["default"].object,
    /** A callback function that will be triggered if the micro-frontend fails to load */
    onError: prop_types_1["default"].func,
    /** Optional placeholder content displayed while loading the micro-frontend */
    children: prop_types_1["default"].node
};
MicroFrontend.defaultProps = {
    containedAppProps: {},
    onError: function () { },
    children: null
};
exports["default"] = MicroFrontend;
//# sourceMappingURL=MicroFrontend.js.map